// Registers the PitchVault service worker (public/service-worker.js) so the app
// can serve cached assets while offline. Registration is skipped outside of
// production builds and on browsers without service-worker support.

const SERVICE_WORKER_URL = '/service-worker.js';

function isSupported() {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}

export function register() {
  if (process.env.NODE_ENV !== 'production' || !isSupported()) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SERVICE_WORKER_URL)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // A newer version has been cached and will activate on next load.
              console.info('PitchVault: new content is available; refresh to update.');
            }
          };
        };
      })
      .catch((error) => {
        console.error('PitchVault: service worker registration failed.', error);
      });
  });
}

export function unregister() {
  if (!isSupported()) {
    return;
  }

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => {
      console.error('PitchVault: service worker unregister failed.', error);
    });
}
